import Token from '@/utils/Token';

export default {
    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/preenchimento-versao/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/preenchimento-versao/list${params}`, Token.getHeader());
    },
    listContrato(contratoId, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/preenchimento-versao/listContrato/${contratoId}${params}`, Token.getHeader());
    },
}